<template>
    <div class="tabs d-flex align-center pointer">
        <v-row no-gutters>
            <v-col cols="6" class="stickers-tab d-flex align-center justify-center">
                <v-btn v-ripple="false" min-height="39" max-width="50%" tile block depressed :class="activeTab === 1 && 'active-tab'" @click="setActiveTab(1)">
                    <img :src="require(`@/assets/icons/stickers_${theme}.png`)" class="mr-1" alt="Stickers">
                    <strong class="fs--13">Stickers</strong>
                </v-btn>
                <div v-if="activeTab === 1" class="tab-border"></div>
            </v-col>
            <v-col cols="6" class="leaderboard-tab d-flex align-center justify-center">
                <v-btn v-ripple="false" min-height="39" max-width="50%" tile block depressed :class="activeTab === 2 && 'active-tab'" @click="setActiveTab(2)">
                    <img :src="require(`@/assets/icons/leaderboard_${theme}.svg`)" class="mr-1" alt="Leaderboard">
                    <strong class="fs--13">Leaderboard</strong>
                </v-btn>
                <div v-if="activeTab === 2" class="tab-border"></div>
            </v-col>
            
        </v-row>


        <!-- <div class="stickers-tab d-flex align-center justify-center" role="button" :class="activeTab === 1 && 'active-tab'"
            @click="setActiveTab(1)">
            <img :src="require(`@/assets/icons/stickers_${theme}.png`)" class="mr-1" alt="Stickers">
            <strong class="fs--13">Stickers</strong>

            <div v-if="activeTab === 1" class="tab-border"></div>
        </div>
        <div class="leaderboard-tab d-flex align-center justify-center" role="button" :class="activeTab === 2 && 'active-tab'"
            @click="setActiveTab(2)">
            <img :src="require(`@/assets/icons/leaderboard_${theme}.svg`)" class="mr-1" alt="Leaderboard">
            <strong class="fs--13">Leaderboard</strong>
            <div v-if="activeTab === 2" class="tab-border"></div>
        </div> -->
    </div>
</template>

<script>
import { useStore } from '@/store'
import { computed } from 'vue'
export default {
    name: 'PanelTabs',
    props: {
        activeTab: { type: Number, default: 1 }
    },
    setup(_, ctx) {
        const store = useStore()
        const theme = computed(() => store.state.theme)

        const setActiveTab = (tab) => {
            ctx.emit('changeTab', tab)
        }

        return {
            theme,
            setActiveTab
        }
    }
}
</script>